export default __webpack_public_path__ + "static/media/contact-1.d74f170b.png";